// extracted by mini-css-extract-plugin
export default {"maxHeight":"SpecifBrand_maxHeight__PN6r0","mt7":"SpecifBrand_mt7__8DJ4w"};